module.exports = __webpack_public_path__ + "img/responsive hospitium-03.16db07d7.jpg";